import {
  AlertTriangle,
  ClipboardList,
  FileText
} from 'lucide-react';

const iconMap = {
  file: FileText,
  alert: AlertTriangle,
  clipboard: ClipboardList
};

export function KPICard({ metric, onClick }) {
  const Icon = iconMap[metric.icon] || FileText;
  const isInteractive = typeof onClick === 'function';

  return (
    <div
      className={`kpi-card ${isInteractive ? 'clickable' : ''}`}
      role={isInteractive ? 'button' : undefined}
      tabIndex={isInteractive ? 0 : undefined}
      onClick={isInteractive ? onClick : undefined}
      onKeyDown={
        isInteractive
          ? (event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onClick();
              }
            }
          : undefined
      }
    >
      <div className="kpi-card-top">
        <div>
          {metric.topIndicator && (
            <span className="kpi-card-indicator">{metric.topIndicator}</span>
          )}
          <p className="kpi-title">{metric.title}</p>
        </div>
        <div className={`kpi-card-icon ${metric.accent || 'info'}`}>
          <Icon style={{ width: '1.25rem', height: '1.25rem' }} />
          {metric.badgeCount ? (
            <span className="kpi-card-badge">{metric.badgeCount}</span>
          ) : null}
        </div>
      </div>
      <div className="kpi-card-bottom">
        <span className="kpi-count">{metric.primaryValue}</span>
        <p className="kpi-description">{metric.description}</p>
      </div>
    </div>
  );
}
